import axios from "../services/api/api";
import {
  FETCH_PROGRAM_LICENSES_BEGIN,
  FETCH_PROGRAM_LICENSES_FULFILLED,
  FETCH_PROGRAM_LICENSES_REJECTED,
  FETCH_PROGRAM_LICENSES_BY_CUSTOMER_BEGIN,
  FETCH_PROGRAM_LICENSES_BY_CUSTOMER_FULFILLED,
  FETCH_PROGRAM_LICENSES_BY_CUSTOMER_REJECTED,
} from "../reducers/programLicenseReducer";

export function fetchProgramLicenses() {
  return function (dispatch) {
    dispatch({ type: FETCH_PROGRAM_LICENSES_BEGIN });
    axios
      .get("/ProgramLicense")
      .then((response) => {
        dispatch({
          type: FETCH_PROGRAM_LICENSES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_PROGRAM_LICENSES_REJECTED,
          payload: err,
        });
      });
  };
}

export function fetchCustomerProgrammeLicenses(customerId) {
  return function (dispatch) {
    dispatch({ type: FETCH_PROGRAM_LICENSES_BY_CUSTOMER_BEGIN });
    axios
      .get("/ProgramLicense/GetByCustomer?customerId=" + customerId)
      .then((response) => {
        dispatch({
          type: FETCH_PROGRAM_LICENSES_BY_CUSTOMER_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_PROGRAM_LICENSES_BY_CUSTOMER_REJECTED,
          payload: err,
        });
      });
  };
}
export function fetchAvailableProgramLicenses() {
  return function (dispatch) {
    dispatch({ type: FETCH_PROGRAM_LICENSES_BEGIN });
    axios
      .get("/ProgramLicense/GetAvailableProgramLicenses")
      .then((response) => {
        dispatch({
          type: FETCH_PROGRAM_LICENSES_FULFILLED,
          payload: response.data.result,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_PROGRAM_LICENSES_REJECTED,
          payload: err,
        });
      });
  };
}
